export const teamMembers = [
  {
    id: 'nertila-basha',
    name: 'Nertila Basha',
    title: 'CEO, Zahn\u00e4rztin, Implantologin & Prothetikerin',
    specialty: 'Zahnimplantate & \u00e4sthetische Prothetik',
    bio: 'Dr. Nertila Basha ist CEO und Zahn\u00e4rztin, Implantologin und Prothetikerin mit umfassender Erfahrung im dentalen Bereich. Sie zeichnet sich durch klinische Pr\u00e4zision und Liebe zum Detail aus und bietet moderne, individuell angepasste Behandlungen f\u00fcr jeden Patienten. Ihr Ziel ist es, funktionale und \u00e4sthetische Ergebnisse auf h\u00f6chstem Niveau zu garantieren, wobei stets die Gesundheit und das Wohlbefinden des Patienten im Mittelpunkt stehen.',
    certifications: ['Fach\u00e4rztin f\u00fcr Zahnmedizin', 'Implantologie & Prothetik', 'Universit\u00e4t Tirana'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/37d99c2b-77e8-4c73-bb19-5697c037374a.png',
  },
  {
    id: 'denisa-zhegu',
    name: 'Denisa Zhegu',
    title: '\u00c4rztin f\u00fcr \u00c4sthetische Medizin',
    specialty: 'Dermo-\u00e4sthetische Behandlungen',
    bio: 'Dr. Denisa Zhegu ist \u00c4rztin f\u00fcr \u00e4sthetische Medizin mit internationaler Ausbildung, spezialisiert auf fortschrittliche dermo-\u00e4sthetische Behandlungen. Sie zeichnet sich durch den Einsatz moderner und sicherer Techniken aus und bietet nat\u00fcrliche, individuell angepasste Ergebnisse f\u00fcr jeden Patienten. Dank ihrer Erfahrung und kontinuierlichen Weiterbildung ist sie eine feste Gr\u00f6\u00dfe in der \u00e4sthetischen Medizin in Tirana.',
    certifications: ['Fach\u00e4rztin \u00c4sthetische Medizin', 'Dermo-\u00e4sthetische Zertifizierung', 'Internationale Akademie'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/78585f7c-fd99-4da5-abcb-6627cb066abf.png',
  },
  {
    id: 'nuri-qyra',
    name: 'Nuri Qyra',
    title: 'An\u00e4sthesist & Intensivmediziner',
    specialty: 'An\u00e4sthesie & Patientensicherheit',
    bio: 'Spezialist mit \u00fcber 40 Jahren Erfahrung in An\u00e4sthesie und Intensivmedizin, der sich der Sicherheit, \u00dcberwachung und dem maximalen Komfort des Patienten w\u00e4hrend jeder medizinischen und chirurgischen Prozedur widmet. Seine Ruhe und Expertise geben Patienten und Team gleicherma\u00dfen Sicherheit.',
    certifications: ['Facharzt An\u00e4sthesie', 'Intensivmedizin', 'Universit\u00e4t Tirana'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/8deb6283-6e81-4dc0-9e57-3ea035d2d3d9.png',
  },
  {
    id: 'nurie-paloka',
    name: 'Nurie Paloka',
    title: 'Leitende OP-Schwester',
    specialty: 'Chirurgische Assistenz & OP-Management',
    bio: 'Mit 37 Jahren Erfahrung in der chirurgischen Assistenz und im OP-Management ist sie dem h\u00f6chsten Niveau an Professionalit\u00e4t, Organisation und Patientenversorgung w\u00e4hrend jeder medizinischen Prozedur gewidmet. Sie koordiniert den gesamten OP-Ablauf mit Pr\u00e4zision und Herz.',
    certifications: ['Leitende OP-Schwester', 'Chirurgische Assistenz', 'Klinikmanagement'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/42643fdb-8629-463b-badb-cb8b716f67d6.png',
  },
  {
    id: 'ermir-mehillej',
    name: 'Ermir Mehillej',
    title: 'Chirurg Implantologe',
    specialty: 'Zahnimplantologie & Chirurgie',
    bio: 'Dr. Ermir Mehillej ist ein Zahnarzt und chirurgischer Implantologe mit 8 Jahren Erfahrung im Bereich. Er ist spezialisiert auf traditionelle Implantologie, pterygoide und zygomatische Implantate und bew\u00e4ltigt auch die komplexesten F\u00e4lle mit Pr\u00e4zision und Kompetenz. Dank seiner langj\u00e4hrigen Erfahrung bietet er sichere, funktionelle und \u00e4sthetisch fortschrittliche L\u00f6sungen f\u00fcr jeden Patienten.',
    certifications: ['Facharzt Zahnmedizin', 'Implantologie-Chirurgie', 'Zygomatische & Pterygoide Implantate'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/7bf68a00-f6b6-47f6-b26a-098f73f4c089.png',
  },
  {
    id: 'roel-ferataj',
    name: 'Roel Ferataj',
    title: 'Chirurg Implantologe',
    specialty: 'Zahnimplantologie & Chirurgie',
    bio: 'Dr. Roel Ferataj ist ein Zahnarzt und chirurgischer Implantologe mit 4 Jahren Erfahrung im Bereich. Er ist spezialisiert auf traditionelle Implantologie, pterygoide und zygomatische Implantate und zeichnet sich durch Pr\u00e4zision und Sorgfalt bei jeder Behandlung aus, auch in den komplexesten F\u00e4llen. Mit einem professionellen Ansatz und gro\u00dfer Aufmerksamkeit f\u00fcr die Bed\u00fcrfnisse des Patienten bietet er moderne, sichere und \u00e4sthetisch harmonische L\u00f6sungen.',
    certifications: ['Facharzt Zahnmedizin', 'Implantologie-Chirurgie', 'Fortgeschrittene Implantologie'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/59836004-bec2-4a83-b623-402b145cf797.png',
  },
  {
    id: 'ana-bardhi',
    name: 'Ana Bardhi',
    title: 'Zahn\u00e4rztin f\u00fcr Prothetik & Endodontie',
    specialty: 'Prothetik, Endodontie & \u00c4sthetische Rehabilitation',
    bio: 'Dr. Ana Bardhi ist eine Spezialistin f\u00fcr Zahnprothetik und Endodontie mit 6 Jahren klinischer Erfahrung. Sie k\u00fcmmert sich um die \u00e4sthetische und funktionelle Rehabilitation des L\u00e4chelns und bietet personalisierte Behandlungen sowie moderne L\u00f6sungen f\u00fcr jeden Patienten. Dank ihrer Professionalit\u00e4t und Liebe zum Detail garantiert sie hochwertige Behandlungen in einem einladenden und sicheren Umfeld.',
    certifications: ['Fach\u00e4rztin Prothetik', 'Endodontie-Spezialistin', '\u00c4sthetische Zahnmedizin'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/a339377d-6155-4cc6-b417-5c91c5df8ad8.png',
  },
  {
    id: 'rigers-xaka',
    name: 'Rigers Xaka',
    title: 'Dentalassistent',
    specialty: 'Klinische Assistenz & Patientenbetreuung',
    bio: 'Rigers Xaka ist ein Dentalassistent mit 2 Jahren Erfahrung im Dentalbereich. Er unterst\u00fctzt das medizinische Team w\u00e4hrend klinischer Prozeduren und tr\u00e4gt dazu bei, ein organisiertes, sicheres und einladendes Umfeld f\u00fcr die Patienten zu gew\u00e4hrleisten. Dank seiner Professionalit\u00e4t und Aufmerksamkeit f\u00fcr Details sorgt er f\u00fcr eine effiziente Assistenz in jeder Phase der Behandlung.',
    certifications: ['Dentalassistent', 'Klinische Unterst\u00fctzung', 'Patientenmanagement'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/49212e52-d1fa-46e1-9399-3dbadb25cf20.png',
  },
  {
    id: 'luciana-basha',
    name: 'Luciana Basha',
    title: 'Endodontistin',
    specialty: 'Wurzelkanalbehandlung & Erhalt nat\u00fcrlicher Z\u00e4hne',
    bio: '\u00c4rztin f\u00fcr Endodontie mit 3 Jahren Erfahrung in Wurzelkanalbehandlungen und der Erhaltung nat\u00fcrlicher Z\u00e4hne. Sie widmet sich pr\u00e4zisen, minimalinvasiven und schmerzfreien Behandlungen, setzt moderne Techniken ein und stellt stets den Komfort und die Gesundheit des Patienten an erste Stelle.',
    certifications: ['Fach\u00e4rztin Endodontie', 'Wurzelkanalspezialistin', 'Universit\u00e4t Tirana'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/565a5664-42a1-4908-a036-0bb3d8b3c39f.png',
  },
  {
    id: 'gezim-kabashi',
    name: 'Gezim Kabashi',
    title: 'Fahrer & Patientenbetreuung',
    specialty: 'Organisatorische Unterst\u00fctzung & Transport',
    bio: 'Spezialisiert auf die umfassende Betreuung von Patienten w\u00e4hrend ihres gesamten Aufenthalts in Albanien. Er bietet organisatorische Unterst\u00fctzung, professionelle Kommunikation und ein komfortables Erlebnis vom Moment der Ankunft bis zur Beendigung der Behandlung.',
    certifications: ['Patientenbetreuung', 'Fahrer', 'Organisationsmanagement'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/a9c20490-9b6c-4c63-bce6-351f8127d8e4.png',
  },
  {
    id: 'griselda',
    name: 'Griselda',
    title: 'Klinikkoordinatorin',
    specialty: 'Klinikmanagement & Patientenkoordination',
    bio: 'Griselda ist die Klinikkoordinatorin und verf\u00fcgt \u00fcber mehr als 10 Jahre Erfahrung in der Verwaltung und Koordination von Kliniken und Krankenhausstrukturen. Dank ihrer organisatorischen F\u00e4higkeiten und ihrer Aufmerksamkeit f\u00fcr die Patienten garantiert sie einen effizienten, professionellen und gut organisierten Behandlungsverlauf. Sie ist der Ansprechpartner f\u00fcr die Betreuung und Unterst\u00fctzung der Patienten w\u00e4hrend aller Phasen der Behandlung.',
    certifications: ['Klinikmanagement', 'Patientenkoordination', 'Gesundheitsverwaltung'],
    languages: ['SQ', 'IT', 'EN', 'DE'],
    imageUrl: 'https://public.readdy.ai/ai/img_res/7553a5ed-fd03-4c3d-bfa3-f2592005fcfc.png',
  },
];